// extracted by mini-css-extract-plugin
export default {"Pokedex":"XzLDjwn8jA0lOW8SpvUt"};